// extracted by mini-css-extract-plugin
export default {"root":"style_root__8sgzM","logo2":"style_logo2__tatUS","item":"style_item__eDlO9","logout":"style_logout__l3Lln"};